'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ad = function (_React$Component) {
  (0, _inherits3.default)(Ad, _React$Component);

  function Ad() {
    (0, _classCallCheck3.default)(this, Ad);
    return (0, _possibleConstructorReturn3.default)(this, (Ad.__proto__ || (0, _getPrototypeOf2.default)(Ad)).apply(this, arguments));
  }

  (0, _createClass3.default)(Ad, [{
    key: 'renderNewAssetAdBody',
    value: function renderNewAssetAdBody() {
      var styles = require('./Ad.scss');

      var _props = this.props,
          date = _props.date,
          title = _props.title,
          description = _props.description,
          type = _props.type,
          tags = _props.tags,
          pack = _props.pack;


      var pathname = pack ? '/megascans/library/packs/' + pack : 'library';
      /* const query = tags ? { search: [].concat(type).concat(tags).join(',') } : undefined;*/

      var query = type && tags ? { search: [].concat(type).concat(tags).join(',') } : tags ? { search: [].concat(tags).join(',') } : undefined;

      return _react2.default.createElement(
        'div',
        { className: styles.AdBody },
        _react2.default.createElement(
          'span',
          { className: styles.AdBody__details },
          _react2.default.createElement(
            'h3',
            { className: styles.AdBody__type },
            'New scans'
          ),
          date && _react2.default.createElement(
            'span',
            { className: styles.AdBody__date },
            date
          )
        ),
        _react2.default.createElement(
          'h1',
          { className: styles.AdBody__title },
          title
        ),
        _react2.default.createElement(
          'p',
          { className: styles.AdBody__description },
          description
        ),
        _react2.default.createElement(_components.Button, {
          className: styles.AdBody__button,
          link: true,
          primary: true,
          to: { pathname: pathname, query: query },
          label: 'Explore all new scans' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props2 = this.props,
          image = _props2.image,
          disabled = _props2.disabled;


      var styles = require('./Ad.scss');
      var style = {
        backgroundImage: 'url(' + image + ')'
      };

      var classes = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.Ad, true), (0, _defineProperty3.default)(_classnames, styles['Ad--disabled'], disabled), _classnames));

      return _react2.default.createElement(
        'section',
        { className: classes, style: style },
        _react2.default.createElement(
          'div',
          { className: styles.Ad__inner },
          _react2.default.createElement(
            'div',
            { className: styles.Ad__bodywrap },
            this.renderNewAssetAdBody()
          )
        )
      );
    }
  }]);
  return Ad;
}(_react2.default.Component);

exports.default = Ad;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Ad/Ad.jsx
// module id = 2497
// module chunks = 0